/* eslint-disable react/no-array-index-key */
import { FC, useState } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { JsResultType } from '../../CodeExample/JsOnlyResult';
import './JsTestsResult.scss';

type JsTestsResultProps = {
	evaluatedResult: JsResultType;
};

const JsTestsResult: FC<JsTestsResultProps> = ({ evaluatedResult }) => {
	const [expandedTest, setExpandedTest] = useState<number | null>();
	if (!evaluatedResult) {
		return null;
	}
	const { tests } = evaluatedResult;

	return (
		<div className="JsOnlyRenderer__code-output">
			<div style={{ margin: 0 }}>
				{tests &&
					tests.map((test, index) => (
						<div
							key={index}
							style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
						>
							<div>
								<div
									className="JsTests__test-item"
									onClick={() => {
										const value = expandedTest === index ? null : index;
										setExpandedTest(value);
									}}
								>
									{test.pass ? (
										<CheckCircleIcon fontSize="small" color="success" />
									) : (
										<RemoveCircleIcon fontSize="small" color="error" />
									)}
									<div style={{ marginLeft: '10px' }}>
										Test {index + 1}: {test?.name}
									</div>
								</div>
								{expandedTest === index && (
									<div
										style={{
											marginLeft: '9px',
											paddingLeft: '21px',
											borderLeft: '2px solid black',
											fontSize: '13px',
										}}
									>
										<div>
											<span style={{ color: '#707070' }}>Input:</span> {test.input}
										</div>
										<div>
											<span style={{ color: '#707070' }}>Expected result:</span>{' '}
											{test.expectedResult}
										</div>
										<div>
											<span style={{ color: '#707070' }}>Actual result:</span>{' '}
											{test.actualResult}
										</div>
									</div>
								)}
							</div>
						</div>
					))}
			</div>
		</div>
	);
};

export default JsTestsResult;
